import React, { useState } from 'react';
import Text from '../Text';
import { st, classes } from './LabelledElement.st.css';
import { DATA_HOOKS } from './LabelledElement.constants';
import { generateID } from '../utils/generateId';
import { LabelledElementProps } from './LabelledElement.types';

const LabelledElement = ({
  dataHook,
  label,
  value,
  topLabelGray,
  disabled,
  children,
}: LabelledElementProps) => {
  const [hasFocus, setHasFocus] = useState(false);
  const [inputValue, setInputValue] = useState<string>();

  const inputId = `labelled-element-${generateID()}`;
  const isInputControlled = typeof value !== 'undefined';
  const isInputEmpty = isInputControlled ? !value : !inputValue;
  const hasTopLabel = hasFocus || !isInputEmpty;

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!isInputControlled) {
      setInputValue(event.target.value);
    }
  };

  return (
    <div className={classes.root} data-hook={dataHook}>
      <label
        data-hook={DATA_HOOKS.label}
        data-top={hasTopLabel}
        htmlFor={inputId}
        className={st(classes.label, {
          labelTop: hasTopLabel,
          topLabelGray,
          disabled,
        })}
      >
        <Text
          size="medium"
          light={!hasTopLabel}
          secondary={!hasTopLabel}
          weight="thin"
          className={classes.labelText}
        >
          {label}
        </Text>
      </label>
      {children && (
        <div data-hook={DATA_HOOKS.childrenWrapper}>
          {children({
            id: inputId,
            onFocus: () => setHasFocus(true),
            onBlur: () => setHasFocus(false),
            onChange: handleOnChange,
            /** should have a different height than regular large input */
            className: classes.inputContainer,
            getPlaceholder: (placeholder?: string) =>
              hasTopLabel ? placeholder : '',
          })}
        </div>
      )}
    </div>
  );
};

LabelledElement.displayName = 'LabelledElement';

export default LabelledElement;
